import { InsurersCodeEnum } from '../../../enums/insurers-code.enum';

export interface FireInsuranceConditionsDocuments {
  insurerName: string;
  residentialUrl?: string;
  commercialUrl?: string;
}

const alfaDocuments: FireInsuranceConditionsDocuments = {
  insurerName: 'Alfa Seguros',
  residentialUrl:
    'https://4seg-documents-analysis.s3.amazonaws.com/Condicoes+Gerais+-+Incendio/Condi%C3%A7%C3%B5es+Gerais+-+Residencial+-+Alfa+Imobili%C3%A1rio.pdf',
  commercialUrl:
    'https://4seg-documents-analysis.s3.amazonaws.com/Condicoes+Gerais+-+Incendio/Condi%C3%A7%C3%B5es+Gerais+-+Comercial+-+Alfa+Imobili%C3%A1rio.pdf'
};

const tokioMarineDocuments: FireInsuranceConditionsDocuments = {
  insurerName: 'Tokio Marine',
  residentialUrl:
    'https://4seg-documents-analysis.s3.amazonaws.com/Condicoes+Gerais+-+Incendio/Condicoes_SeguroIncendio_Tokio_Marine_Residencial.pdf',
  commercialUrl:
    'https://4seg-documents-analysis.s3.amazonaws.com/Condicoes+Gerais+-+Incendio/Condicoes_SeguroIncendio_Tokio_Marine_Empresarial.pdf'
};

const yelumDocuments: FireInsuranceConditionsDocuments = {
  insurerName: 'Yelum Seguros',
  residentialUrl:
    'https://4seg-documents-analysis.s3.us-east-1.amazonaws.com/Condicoes+Gerais+-+Incendio/202505_Yelum_Condicoes_Gerais_Imobiliario_Residencial%5B4%5D.pdf',
  commercialUrl:
    'https://4seg-documents-analysis.s3.us-east-1.amazonaws.com/Condicoes+Gerais+-+Incendio/202505_Yelum_Condicoes_Gerais_Imobiliario_Empresarial%5B24%5D.pdf'
};

const pottencialDocuments: FireInsuranceConditionsDocuments = {
  insurerName: 'Pottencial Seguradora'
};

const portoDocuments: FireInsuranceConditionsDocuments = {
  insurerName: 'Porto Seguro'
};

const documentsByInsurerCode: Record<string, FireInsuranceConditionsDocuments> = {
  [InsurersCodeEnum.alfa]: alfaDocuments,
  [InsurersCodeEnum.TokioMarine]: tokioMarineDocuments,
  [InsurersCodeEnum.TokioMarineSegimob]: tokioMarineDocuments,
  [InsurersCodeEnum.Yelum]: yelumDocuments,
  [InsurersCodeEnum.Pottencial]: pottencialDocuments,
  [InsurersCodeEnum.Porto]: portoDocuments,
  [InsurersCodeEnum.PortoEssencial]: portoDocuments,
  [InsurersCodeEnum.Porto12]: portoDocuments,
  [InsurersCodeEnum.Porto18]: portoDocuments,
  [InsurersCodeEnum.Porto20]: portoDocuments,
  [InsurersCodeEnum.Porto30]: portoDocuments
};

export const getFireInsuranceConditionsDocuments = (
  insurerCode?: string
): FireInsuranceConditionsDocuments | undefined =>
  insurerCode ? documentsByInsurerCode[insurerCode] : undefined;
